import { Link } from 'react-router-dom';
import { SeoHead, organizationLd, webSiteLd, webPageLd } from '../seo';
import cities from '../data/cities.json';

export default function Seekers() {
  return (
    <>
      <SeoHead
        title="Find Parking Near You — Free Seeker Map | Parksy"
        description="Looking for parking in your area? Drop a seeker pin on Parksy.rent. We'll email you when compatible spots open within 3 km. No signup."
        canonical="https://parksy.rent/seekers"
        ogImage="https://parksy.rent/og/seekers.png"
        schemas={[organizationLd(), webSiteLd(), webPageLd({ name: 'Find Parking', description: 'Drop a seeker pin and get matched with parking near you.', url: 'https://parksy.rent/seekers' })]}
      />
      <div className="max-w-3xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Find parking. Get notified. Pay fairly.</h1>
        <p className="text-lg text-gray-600 mb-8">
          Drop a pin where you need parking. We scan daily and email you the moment a compatible
          spot opens within 3 km — across all of India, no signup required.
        </p>

        <Link
          to="/"
          className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-medium px-6 py-3 rounded-lg mb-12"
        >
          Open the map and drop a seeker pin →
        </Link>

        <h2 className="text-2xl font-semibold text-gray-900 mb-4">Active in {cities.length} cities</h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 text-sm">
          {cities.map((c) => (
            <Link
              key={c.slug}
              to={`/${c.slug}`}
              className="bg-white border rounded-lg px-3 py-2 text-gray-700 hover:border-parksy-500 hover:text-parksy-700"
            >
              Parking in {c.name}
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}
